import { User } from 'firebase/auth';
import { useState, useCallback, useEffect } from 'react';

import { getCoupons, getCoupon } from '~/restApi/coupon';

import { PLATFORM_ID } from '~/globalVariables';

import { CampaignType, Coupon } from '~/types/coupon';
import { FetchingDataStatus } from '~/types/utilities';
export default function useCoupon(auth: User | null, id: string) {
  const [coupon, setCoupons] = useState<Coupon>({
    id: '',
    stores: [],
    startDate: '',
    endDate: '',
    allowDisplay: true,
    name: '',
    description: '',
    note: '',
    code: '',
    type: CampaignType.DISCOUNT,
    condition: {},
  });
  const [couponFetchingStatus, setCouponFetchingStatus] = useState(FetchingDataStatus.INIT);

  const handleGetCoupons = useCallback(async (platformId: string, auth: User, id: string) => {
    try {
      setCouponFetchingStatus(FetchingDataStatus.LOADING);
      const res = await getCoupon(platformId, auth, id);

      setCoupons(res);
      setCouponFetchingStatus(FetchingDataStatus.SUCCESS);
    } catch (err) {
      setCouponFetchingStatus(FetchingDataStatus.FAIL);
    }
  }, []);

  useEffect(() => {
    if (auth) {
      handleGetCoupons(PLATFORM_ID, auth, id);
    }
  }, [handleGetCoupons, auth, id]);

  return { coupon, couponFetchingStatus };
}
